import React, { useEffect, useMemo, useState } from 'react'
import Loading from '../feedback/Loading'
import toast from 'react-hot-toast'
import utils from '../../utils'
import { HiTrash } from 'react-icons/hi'
import { useSession } from '../../context/SessionContext'
import productServices from '../../services/ProductsServices'
import moment from 'moment'

function ProductModelModal(props) {
    const brands = props.brands
    const [name, setName] = useState("")
    const [loading, setLoading] = useState(false)
    const [brand, setBrand] = useState()
    const action = props.action
    const activeModel = props.activeModel
    const { setModels } = useSession()
    const [activeTab, setActiveTab] = useState(0)

    // Tabs: Info + Delete (only if editing)
    const tabs = useMemo(() => {
        const baseTabs = ['Info'];
        if (action === 1) {
            return [...baseTabs, 'Delete'];
        }
        return baseTabs;
    }, [action]);

    useEffect(() => {
        if (action === 1 && activeModel) {
            setName(activeModel?.name)
            // No need to set brand since it's read-only in view mode
        }
    }, [action, activeModel])

    async function updateSession() {
        productServices.getModels().then(
            res => {
                setModels(res.data)
            },
            err => {
                console.log("Session update error");
                console.log(err);
            }
        )
    }

    function submitHandler(e) {
        const closeBtn = document.getElementById("product-model-modal-close-btn")
        e.preventDefault()
        setLoading(true)
        const data = {
            "name": name,
            "brand": brand
        }
        productServices.addProductModel(data).then(
            res => {
                toast.success("Product Model Added Successfully")
                setLoading(false)
                props.getModels()
                updateSession()
                closeBtn.click()
            },
            err => {
                toast.error(utils.toastError)
                console.log(err);
                setLoading(false)
            }
        )
    }

    function deleteHandler(id) {
        const closeBtn = document.getElementById("product-model-modal-close-btn")
        setLoading(true)
        productServices.deleteModel(id).then(
            res => {
                toast.success("Model Deleted Successfully")
                setLoading(false)
                props.getModels()
                updateSession()
                closeBtn.click()
            },
            err => {
                toast.error(utils.toastError)
                console.log(err);
                setLoading(false)
            }
        )
    }

    const changeTab = (idx) => {
        if (action === 1) {
            setActiveTab(idx);
        }
    };

    const clearInput = () => {
        setName("")
        setBrand(null)
        setActiveTab(0)
    }

    return (
        <div>
            <label htmlFor="product-model-modal" id='product-model-open-btn' className="hidden">Add / Update Model</label>
            <input type="checkbox" id="product-model-modal" className="modal-toggle" />
            <div className="modal">
                <div className="modal-box w-8/11 max-w-2xl">
                    <label
                        onClick={clearInput}
                        htmlFor="product-model-modal"
                        id='product-model-modal-close-btn'
                        className="btn btn-sm btn-circle btn-ghost absolute right-2 top-2">✕</label>

                    <h2 className='text-lg font-bold mb-2'>
                        {action === 1 ? 'View' : 'Add'} Product Model
                        {action === 1 && activeModel && (
                            <span className='ml-2 text-gray-500'>{activeModel?.name}</span>
                        )}
                    </h2>

                    {/* Tabs */}
                    <div className="flex justify-center mb-6">
                        <div className="border-gray-200 dark:border-border-dark">
                            <div className="tabs tabs-boxed justify-center">
                                {tabs.map((tab, idx) => (
                                    // eslint-disable-next-line jsx-a11y/anchor-is-valid
                                    <a
                                        key={idx}
                                        className={`tab ${activeTab === idx
                                            ? 'tab-active bg-primary text-white rounded-lg'
                                            : ''
                                            }`}
                                        onClick={() => changeTab(idx)}
                                        role="tab"
                                        aria-selected={activeTab === idx}
                                    >
                                        {tab}
                                    </a>
                                ))}
                            </div>
                        </div>
                    </div>

                    {/* Info Tab */}
                    {activeTab === 0 && (
                        <>
                            {action === 1 && activeModel && (
                                <div className='mb-4 grid grid-cols-1 gap-3 md:grid-cols-2'>
                                    <div className="flex justify-center">
                                        <div className="avatar placeholder">
                                            <div className="bg-neutral text-neutral-content text-lg rounded-md h-36 w-36">
                                                {String(activeModel?.name).charAt(0).toLocaleUpperCase()}
                                            </div>
                                        </div>
                                    </div>
                                    <div className='border p-3 rounded-lg shadow-md'>
                                        <p className="font-bold mb-1">Overview</p>
                                        <div>
                                            <p><span className='font-bold mr-2'>Brand Name:</span> {activeModel?.brand?.name || "-"}</p>
                                            <p><span className='font-bold mr-2'>Product Count:</span> {activeModel?.product_count}</p>
                                            <p>Created On: <span className='font-bold ml-3 text-gray-600'>{moment(activeModel?.creation_time).format("MMM Do YYYY")}</span></p>

                                        </div>
                                    </div>
                                </div>
                            )}

                            <form onSubmit={submitHandler}>
                                <div className="form-control mb-3">
                                    <label className="label">
                                        <span className="label-text">Name:</span>
                                    </label>
                                    <input
                                        value={name}
                                        onChange={(e) => setName(e.target.value)}
                                        type="text"
                                        required
                                        className="input input-bordered w-full"
                                    />
                                </div>

                                {action === 0 && (
                                    <div className="form-control mb-5">
                                        <label className="label">
                                            <span className="label-text">Brand:</span>
                                        </label>
                                        <select
                                            className='select select-bordered w-full'
                                            onChange={(e) => setBrand(parseInt(e.target.value))}
                                            required
                                        >
                                            <option value="" disabled>Select Brand</option>
                                            {brands?.map((brand, idx) => (
                                                <option key={brand?.id || idx} value={brand?.id}>{brand?.name}</option>
                                            ))}
                                        </select>
                                    </div>
                                )}

                                {action === 0 && (
                                    <div className='mt-6'>
                                        <button
                                            className="w-full flex justify-center py-3 px-4 border border-transparent rounded-md shadow-sm text-sm font-medium text-white bg-primary hover:bg-red-800 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-primary disabled:opacity-75"
                                            type="submit"
                                            disabled={loading}
                                        >
                                            {loading ? 'Adding...' : 'Add'}
                                        </button>
                                    </div>
                                )}
                            </form>
                        </>
                    )}

                    {/* Delete Tab */}
                    {activeTab === 1 && action === 1 && (
                        <div className="border-base-200">
                            <div className="bg-white dark:bg-slate-800 rounded-lg shadow-sm border border-border-light dark:border-border-dark overflow-hidden">
                                <div className="p-6 md:p-8">
                                    <div className="border-l-4 border-error pl-4 py-2">
                                        <h3 className="font-bold text-error">Warning</h3>
                                        <p className="text-sm text-gray-600 dark:text-gray-400 mt-2">
                                            Deleting this model is irreversible and will also delete all related products.
                                        </p>
                                        <div className="pt-4">
                                            {loading ? (
                                                <Loading />
                                            ) : (
                                                <button
                                                    type="button"
                                                    onClick={() => deleteHandler(activeModel?.id)}
                                                    className="flex items-center space-x-2 bg-error text-white px-4 py-2 rounded-lg text-sm font-medium hover:bg-error/90 transition-colors"
                                                >
                                                    <HiTrash className="h-4 w-4" />
                                                    <span>Delete Model</span>
                                                </button>
                                            )}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    )}
                </div>
            </div>
        </div>
    )
}

export default ProductModelModal